export default __webpack_public_path__ + "static/media/slide-3.6a353524.png";